import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';

import usePagination from '@hooks/usePagination';

import CreateOrUpdateMoodboard from '@features/trend-research/components/moodboard/components/CreateOrUpdateMoodboard';
import { useFetchMoodBoardsQuery } from '@features/trend-research/api/moodboardApi';

import { changeDateFormat } from '@utils/Util';

const Moodboard = () => {
	const navigate = useNavigate();
	const [search, setSearch] = useState('');
	const [sort, setSort] = useState('id,desc');
	const [products, setProducts] = useState([]);
	const [debouncedSearch, setDebouncedSearch] = useState(search);
	const [isShowTextBox, setIsShowTextBox] = useState(false);
	const [isShowCreateModal, setIsShowCreateModal] = useState(false);
	const [page, setPage] = useState(0);
	let params = `?size=20&page=${page}&sort=${sort}`;
	if (debouncedSearch) {
		params += `&search=${debouncedSearch}`;
	}
	const { data: moodBoardResponse, isLoading, refetch } = useFetchMoodBoardsQuery(params);
	const stateRef = useRef({
		data: [],
		currentPage: 0,
		totalElements: 0,
		totalPages: 0
	});
	usePagination(stateRef, moodBoardResponse, setProducts, setPage);

	useEffect(() => {
		const handler = setTimeout(() => {
			setPage(0);
			setDebouncedSearch(search);
		}, 800);

		return () => {
			clearTimeout(handler);
		};
	}, [search]);

	const onCloseCreateModal = () => {
		setIsShowCreateModal(false);
	};

	const renderItems = () => {
		const defaultImage = `${process.env.PUBLIC_URL}/images/trend/moodboard-default-image.png`;
		return products?.map((item, idx) => {
			const images = item.imageUrlList || [];
			const filledImages = [...images, ...Array(4 - images.length).fill(defaultImage)].slice(0, 4);
			return (
				<div
					className="fabric-product-single cursor-pointer"
					key={`trend_mood_board_${idx}`}
					onClick={() => navigate(`/moodboard/${item.id}`)}
				>
					<div className="design-images">
						{filledImages?.map((image, i) => (
							<img src={image} key={`mood_board_image_${i}`} />
						))}
					</div>
					<div className="product-content">
						<p className="regular-14 weight-500 gray_dark_01 pb-1">{item.name}</p>
						<ul className="common-list-component mt-1">
							{item.brandName && <li className="regular-14  gray_dark_02">{item.brandName}</li>}
							{item.createdBy && <li className="regular-14  gray_dark_02">{item.createdBy}</li>}
							{item.createdAt && (
								<li className="regular-14  gray_dark_02">
									{changeDateFormat(item.createdAt, 'YYYY-MM-DD', 'DD MMM, YY')}
								</li>
							)}
						</ul>
					</div>
				</div>
			);
		});
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="top-header ">
				<div className="trend-list">
					<div className="page-title-area pb-2 d-flex align-items-center">
						<h1 className="semibold-16">Mood Board</h1>
					</div>
				</div>
				<div className="filter-container-top filter-container-top-v2 transparent-bg bg-white">
					<div className="filters">
						<div className="chip-container">
							{stateRef.current?.totalElements > 0 && (
								<span className="regular-14 weight-500 gray_dark_01">
									{stateRef.current?.totalElements} items
								</span>
							)}
						</div>
					</div>
					<div className="filter-actions compare-filter-actions">
						<div className="form-group size32 m-0 mr-1 search-filter filter-with-animation">
							<div className={`with-icon right-icon ${!isShowTextBox ? 'hidden' : ''}`}>
								<input
									type="text"
									placeholder="Search"
									value={search}
									onChange={(e) => setSearch(e.target.value)}
								/>
								<span
									className="right-icon"
									onClick={() => setIsShowTextBox((prev) => !prev)}
								>
									<img src={`${process.env.PUBLIC_URL}/icons/search.png`} alt="" />
								</span>
							</div>
						</div>
						<div className="sort-button">
							<select name id className="border-0" onChange={(e) => setSort(e.target.value)}>
								<option value="id,desc">Most Recent</option>
								<option value="id">Oldest</option>
							</select>
						</div>
						<div className="add-new-design">
							<button
								className="button text size32 px-0"
								onClick={() => setIsShowCreateModal(true)}
							>
								<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
								<span className="ml-1 gray_dark_02">Moodboard</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<section className="trend-data-container bg-white body-content">
				<div className="fabric-product-section">
					<div className="fabric-product-all-item">{renderItems()}</div>
				</div>
			</section>
			{isShowCreateModal && (
				<CreateOrUpdateMoodboard
					onClose={onCloseCreateModal}
					callBack={() => {
						window.scrollTo(0, 0);
						setPage(0);
						refetch();
					}}
					title="Create New Moodboard"
					type="CREATE"
				/>
			)}
		</LoaderComponent>
	);
};

export default Moodboard;
